import React, { useState } from 'react'
import gql from 'graphql-tag'
import Divider from 'components/Divider'
import { DataTable } from 'components/DataTable'
import ContentBlock from 'components/ContentBlock'
import DateTimePicker from 'components/forms/DateTimePicker/DateTimePicker'
import dateTimeFormatter from 'helpers/dateTimeFormatter'
import DownloadLogs from 'sections/options/sections/GlobalCashRegisters/pages/DeviceUpdate/DownloadLogs'

const query = gql`
query listDeviceLogs($hardwareId: ID!, $startTime: DateTime, $endTime: DateTime, $params: ListQueryArgs) {
  listDeviceLogs(
    hardwareId: $hardwareId,
    startTime: $startTime,
    endTime: $endTime,
    params: $params,
  ) {
		items {
      message
      timestamp
    }
    cursors {
      before
      after
      hasNext
    }
  }
}
`

export const Logs = ({ data, ...rest }) => {
	const [date, setDate] = useState('')
	const [time, setTime] = useState('')

	const fullTime = `${date.split('T')[0]}T${time.split('T')[1]}`

	return(
		<ContentBlock>
			<DownloadLogs
				deviceId={data.id}
				deviceName={data.name}
			/>
			<Divider/>
			<DateTimePicker
				noForm
				label='Start from'
				value={date}
				onChange={setDate}
			/>
			<DateTimePicker
				noForm
				picker='time'
				value={time}
				onChange={setTime}
			/>
			<DataTable
				height={600}
				resizable={false}
				columns={[{
					Header: 'Timestamp',
					accessor: 'timestamp',
					width: 150,
					Cell: ({ value }) => dateTimeFormatter(value)
				}, {
					Header: 'Message',
					accessor: 'message'
				}]}
				remoteOptions={{
					query: query,
					skip: !data.hardwareId || !date || !time,
					variables: {
						hardwareId: data.hardwareId,
						startTime: fullTime
					}
				}}
			/>
		</ContentBlock>
	)
}
